export const ScreenLocation = (fields) => ({
  type: 'GET_SCREEN',
  payload: fields,
});

export const ChangeScreen = (fields) => ({
  type: 'CHANGE_SCREEN',
  payload: fields,
});

export const EnableSpinner = () => ({
  type: 'ENABLE_SPINNER',
});

export const DisableSpinner = () => ({
  type: 'DISABLE_SPINNER',
});

export const CancelSubmit = () => ({
  type: 'CANCEL_SUBMIT',
});
